export const QUESTIONNAIRE_TYPES = {
	Patient: 1,
	Caregiver: 2,
	Physician: 3,
	Other: 4,
};

export default {}
